import React from 'react';

export const ContextCalculator = React.createContext();